(() => {
  'use strict';
  if (window.ulvivaUIReady) return;
  window.ulvivaUIReady = true;
  const configNode = document.getElementById('UlvivaContactConfig');
  let config = {};
  try { config = JSON.parse(configNode?.textContent || '{}'); } catch { /* Liquid fallback links remain useful. */ }
  const number = String(config.number || '').replace(/[+\s()\-]/g, '');
  const validNumber = /^[1-9]\d{7,14}$/.test(number) && config.enabled;
  const phone = number.startsWith('34') && number.length === 11 ? `+34 ${number.slice(2,5)} ${number.slice(5,8)} ${number.slice(8)}` : `+${number}`;
  const init = (root = document) => {
    root.querySelectorAll('[data-uv-phone]').forEach(el => { el.textContent = validNumber ? phone : ''; });
    root.querySelectorAll('[data-uv-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      menu.addEventListener('toggle', () => { summary.setAttribute('aria-expanded', String(menu.open)); summary.setAttribute('aria-label', menu.open ? 'Cerrar menú' : 'Abrir menú'); });
      menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.open = false; summary.focus(); } });
      menu.addEventListener('click', event => { if (event.target.closest('a')) menu.open = false; });
      menu.addEventListener('focusout', event => { if (event.relatedTarget && !menu.contains(event.relatedTarget)) menu.open = false; });
    });
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => { if (entry.isIntersecting) { entry.target.classList.add('is-entering'); observer.unobserve(entry.target); } }), { threshold: .1 });
      root.querySelectorAll('[data-uv-reveal]:not(.is-entering)').forEach(el => observer.observe(el));
    }
  };
  const syncVariant = variant => {
    if (!variant || !validNumber) return;
    document.querySelectorAll('[data-uv-whatsapp][data-kind="product"][data-source="product"]').forEach(link => {
      const productUrl = new URL(link.dataset.productUrl || location.href, location.origin);
      productUrl.searchParams.set('variant', String(variant.id));
      const message = String(config.productMessage || '').replaceAll('[producto]', link.dataset.product || '').replaceAll('[formato]', variant.title || '').replaceAll('[url]', productUrl.href);
      link.href = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    });
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, event => { syncVariant(event.data?.variant); init(); });
  document.addEventListener('ulviva:variant-change', event => syncVariant(event.detail?.variant));
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-uv-menu][open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
    const link = event.target.closest('[data-uv-whatsapp]');
    // Only use an already present integration. Never include query text or visitor details.
    if (link && Array.isArray(window.dataLayer)) window.dataLayer.push({event:'ulviva_whatsapp_click',source:link.dataset.source || 'unknown',product:link.dataset.product || undefined,kind:link.dataset.kind || 'general'});
  });
  const float = document.querySelector('.uv-whatsapp-float');
  if (float) {
    const visibleScenes = new Set();
    const visibleContactLinks = new Set();
    const updateFloat = () => float.classList.toggle('is-obscured', visibleScenes.size > 0 || visibleContactLinks.size > 0 || Boolean(document.querySelector('cart-drawer.active, #cart-notification.active, .product-media-modal[open], .uv-product-gallery__dialog[open], [data-uv-menu][open]')) || Boolean(document.activeElement?.closest('input,textarea,select')));
    const observer = new MutationObserver(updateFloat);
    document.querySelectorAll('cart-drawer, #cart-notification, .product-media-modal, .uv-product-gallery__dialog, [data-uv-menu]').forEach(el => observer.observe(el,{attributes:true,attributeFilter:['class','open']}));
    if ('IntersectionObserver' in window) {
      const visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => { const set = entry.target.matches('ulviva-studio') ? visibleScenes : visibleContactLinks; if (entry.isIntersecting) set.add(entry.target); else set.delete(entry.target); });
        updateFloat();
      },{threshold:0});
      document.querySelectorAll('ulviva-studio, [data-uv-whatsapp]').forEach(el => { if (!float.contains(el)) visibility.observe(el); });
    }
    document.addEventListener('focusin',updateFloat);document.addEventListener('focusout',()=>requestAnimationFrame(updateFloat));
  }
  init();
})();
